import PropTypes from 'prop-types';

export const feeProps = PropTypes.shape({
  sku: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.number,
  amount: PropTypes.number,
  pass_type: PropTypes.number,
  is_lottery: PropTypes.bool
});

export const ruleProps = PropTypes.shape({
  permit_id: PropTypes.string,
  division_id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.number,
  operation: PropTypes.string,
  target: PropTypes.string,
  value: PropTypes.number,
  start_date: PropTypes.any,
  end_date: PropTypes.any
});

export const divisionProps = PropTypes.shape({
  id: PropTypes.string,
  permit_id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  is_active: PropTypes.bool,
  status: PropTypes.number,
  fees: PropTypes.arrayOf(feeProps)
});

export const AVAILABILITIES = PropTypes.objectOf(PropTypes.shape({
  divisionId: PropTypes.string,
  permitId: PropTypes.string,
  result: PropTypes.shape({
    bools: PropTypes.object,
    nums: PropTypes.object,
    quota_type_maps: PropTypes.object
  })
}));


export const PERMIT_COMPONENTS = PropTypes.shape({
  alternate_group_leader: PropTypes.bool,
  animal_list: PropTypes.bool,
  checkout_next_day: PropTypes.bool,
  commercial_guide_question: PropTypes.bool,
  emergency_contact: PropTypes.bool,
  entry_exit_points: PropTypes.bool,
  entry_points: PropTypes.bool,
  fee_by_date_range: PropTypes.bool,
  group_member_list: PropTypes.bool,
  group_with_age: PropTypes.bool,
  group_with_birthdates: PropTypes.bool,
  group_with_fees_and_dates: PropTypes.bool,
  group_with_fees_only: PropTypes.bool,
  houseboat_list: PropTypes.bool,
  launch_time: PropTypes.bool,
  member_counter: PropTypes.bool,
  member_counter_ruby: PropTypes.bool,
  permit_holder_age: PropTypes.bool,
  permit_holder_birthdate: PropTypes.bool,
  permit_section_filter: PropTypes.bool,
  pet_list: PropTypes.bool,
  prior_experience: PropTypes.bool,
  reload_stay_limit: PropTypes.bool,
  reservation_type_question: PropTypes.bool,
  simple_group_list: PropTypes.bool,
  snowmobile: PropTypes.bool,
  travel_method_list: PropTypes.bool,
  vehicle_list: PropTypes.bool,
  watercraft_details: PropTypes.bool,
  watercraft_list: PropTypes.bool,
  watercraft_pere_marquette: PropTypes.bool
});

// Not complete because the permit struct is huge. Fill in as needed.
export const PERMIT = PropTypes.shape({
  acquisition_types: PropTypes.array,
  activities: PropTypes.arrayOf(PropTypes.object),
  addresses: PropTypes.arrayOf(PropTypes.object),
  animals: PropTypes.array,
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  components: PERMIT_COMPONENTS,
  description: PropTypes.shape({
    description: PropTypes.string,
    quota_details: PropTypes.string
  }),
  directions: PropTypes.string,
  divisions: PropTypes.objectOf(PropTypes.shape({
    child_distances: PropTypes.object,
    children: PropTypes.array,
    code: PropTypes.string,
    commercial_fees: PropTypes.array,
    description: PropTypes.string,
    description_maps: PropTypes.shape({
      need_to_know: PropTypes.string
    }),
    district: PropTypes.string,
    entry_ids: PropTypes.array,
    exit_ids: PropTypes.array,
    fee_calculation_modal: PropTypes.number,
    fee_display_modal: PropTypes.number,
    fees: PropTypes.array,
    houseboats: PropTypes.array,
    id: PropTypes.string,
    is_active: PropTypes.bool,
    is_hidden: PropTypes.bool,
    latitude: PropTypes.number,
    legacy_id: PropTypes.string,
    longitude: PropTypes.number,
    modified_time: PropTypes.string,
    motor_hp_limit: PropTypes.string,
    name: PropTypes.string,
    permit_id: PropTypes.string,
    status: PropTypes.number,
    town: PropTypes.string,
    type: PropTypes.string,
    view_order: PropTypes.number,
    isStartingPoint: PropTypes.bool,
    childDivisions: PropTypes.array
  })),
  email: PropTypes.string,
  entrances: PropTypes.arrayOf(PropTypes.object),
  equipments: PropTypes.arrayOf(PropTypes.object),
  fulfillment_types: PropTypes.array,
  has_lottery: PropTypes.bool,
  id: PropTypes.string,
  important_dates: PropTypes.arrayOf(PropTypes.object),
  is_group: PropTypes.bool,
  latitude: PropTypes.number,
  launch_window_close: PropTypes.string,
  launch_window_open: PropTypes.string,
  launch_window_step: PropTypes.number,
  legacy_id: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object),
  longitude: PropTypes.number,
  lotteries: PropTypes.arrayOf(PropTypes.object),
  map_url: PropTypes.string,
  media: PropTypes.arrayOf(PropTypes.object),
  modified_time: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.number,
  rules: PropTypes.arrayOf(ruleProps),
  permit_sections: PropTypes.arrayOf(
      PropTypes.shape({
          name: PropTypes.string,
          division_ids: PropTypes.arrayOf(PropTypes.string)
      })
  ),
  recareas: PropTypes.arrayOf(PropTypes.string),
  time_zone: PropTypes.string,
  org_code: PropTypes.string,
  org_facility: PropTypes.string,
  org_name: PropTypes.string,
  orgs: PropTypes.string,
  pets: PropTypes.array,
  phone: PropTypes.string,
  rating: PropTypes.shape({
    num_ratings: PropTypes.number,
    rating: PropTypes.number
  }),
  recarea_name: PropTypes.string,
  rules_map: PropTypes.any,
  tags: PropTypes.array,
  travel_methods: PropTypes.array,
  validations: PropTypes.arrayOf(PropTypes.object),
  indexed_rules: PropTypes.shape({})
});

export const permitProps = PERMIT;

export const COMMERCIAL_FIELDS = PropTypes.shape({
  client_info: PropTypes.string,
  service_type: PropTypes.string
});

export const ITINERARY = PropTypes.shape({
  division_id: PropTypes.string,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  quota_type: PropTypes.number
});

export const EQUIPMENT = PropTypes.shape({
  type: PropTypes.number,
  qty: PropTypes.number,
  weight: PropTypes.number,
  description: PropTypes.string,
  license_plate: PropTypes.string,
  license_state: PropTypes.string,
  encrypted_license_plate: PropTypes.string
});

export const INDIVIDUAL = PropTypes.shape({
  first_name: PropTypes.string,
  middle_name: PropTypes.string,
  last_name: PropTypes.string,
  phone: PropTypes.string,
  remark: PropTypes.string,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  pass_type: PropTypes.number,
  fee_type: PropTypes.string,
  passholder_id: PropTypes.string,
  email: PropTypes.string,
  is_verified: PropTypes.bool,
  user_id: PropTypes.string,
  is_leader: PropTypes.bool,
  alternate_group_leader_id: PropTypes.string,
  is_adult: PropTypes.bool,
  is_child: PropTypes.bool,
  is_dog: PropTypes.bool,
  date_of_birth: PropTypes.string,
  age: PropTypes.number,
  is_declined: PropTypes.bool,
  company_name: PropTypes.string,
  encrypted_first_name: PropTypes.string,
  encrypted_middle_name: PropTypes.string,
  encrypted_last_name: PropTypes.string,
  encrypted_phone: PropTypes.string,
  encrypted_email: PropTypes.string,
  encrypted_date_of_birth: PropTypes.string
});

export const ADDRESS = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  street_address1: PropTypes.string,
  street_address2: PropTypes.string,
  street_address3: PropTypes.string,
  city: PropTypes.string,
  state_code: PropTypes.string,
  postal_code: PropTypes.string,
  country_code: PropTypes.string,
  description1: PropTypes.string,
  description2: PropTypes.string,
  remarks: PropTypes.string,
  phone: PropTypes.string,
  encrypted_street_address_1: PropTypes.string,
  encrypted_street_address_2: PropTypes.string,
  encrypted_street_address_3: PropTypes.string,
  encrypted_state_code: PropTypes.string,
  encrypted_city: PropTypes.string,
  encrypted_postal_code: PropTypes.string
});

export const ISSUANCE = PropTypes.shape({
  user_id: PropTypes.string,
  group_leader_id: PropTypes.string,
  permit_id: PropTypes.string,
  division_id: PropTypes.string,
  lottery_id: PropTypes.string,
  allocation_id: PropTypes.string,
  id: PropTypes.string,
  cooperator_id: PropTypes.string,
  admin_justification: PropTypes.string,
  pickup_location_id: PropTypes.string,
  entry_location_id: PropTypes.string,
  exit_location_id: PropTypes.string,
  driver_license: PropTypes.string,
  driver_license_hash: PropTypes.string,
  encrypted_driver_license: PropTypes.string,
  comment: PropTypes.string,
  application_id: PropTypes.string,
  order_id: PropTypes.string,
  reservation_number: PropTypes.string,
  org_type: PropTypes.string,
  org_name: PropTypes.string,
  motor_size: PropTypes.string,
  legacy_id: PropTypes.string,
  envelope_key_id: PropTypes.string,
  encrypted_envelope_key: PropTypes.string,
  initialization_vector: PropTypes.string,
  service_key_id: PropTypes.string,
  fee_override_justification: PropTypes.string,
  prior_experience: PropTypes.string,
  launch_time: PropTypes.string,
  lottery_issuance_id: PropTypes.string,
  watercraft_details: PropTypes.string,
  date_issued: PropTypes.string,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  pickup_date: PropTypes.string,
  updated_on: PropTypes.string,
  time_to_release: PropTypes.string,
  order_date: PropTypes.string,
  permit_type: PropTypes.string,
  group_size: PropTypes.number,
  amount_paid: PropTypes.number,
  payment_type: PropTypes.number,
  modification_count: PropTypes.number,
  processing_sequence: PropTypes.number,
  status: PropTypes.number,
  is_admin_quota: PropTypes.bool,
  is_override_quota: PropTypes.bool,
  is_issue_anytime: PropTypes.bool,
  lottery_applied: PropTypes.bool,
  lottery_awarded: PropTypes.bool,
  lottery_accepted: PropTypes.bool,
  need_to_know_checked: PropTypes.bool,
  is_extended: PropTypes.bool,
  is_commercially_guided: PropTypes.bool,
  is_nonprofit_org: PropTypes.bool,
  is_visiting_canada: PropTypes.bool,
  bwcaw_include_deposit: PropTypes.bool,
  is_visiting_mt_whitney: PropTypes.bool,
  is_bringing_animals: PropTypes.bool,
  is_modify_quota: PropTypes.bool,
  transaction_ids: PropTypes.arrayOf(PropTypes.string),
  alt_group_leaders: PropTypes.arrayOf(PropTypes.shape({})),
  group_info: PropTypes.arrayOf(PropTypes.shape({})),
  equipments: PropTypes.arrayOf(EQUIPMENT),
  animals: PropTypes.arrayOf(PropTypes.shape({})),
  pets: PropTypes.arrayOf(PropTypes.shape({})),
  lottery_preferences: PropTypes.arrayOf(PropTypes.shape({})),
  guides: PropTypes.arrayOf(PropTypes.shape({})),
  itinerary: PropTypes.arrayOf(ITINERARY),
  fee_overrides: PropTypes.arrayOf(PropTypes.shape({})),
  selected_lottery_preference: PropTypes.shape({}),
  emergency_contact: PropTypes.shape({}),
  purchasing_user: PropTypes.shape({}),
  permit_holder: INDIVIDUAL,
  alt_permit_holder: PropTypes.shape({}),
  purchasing_user_address: PropTypes.shape({}),
  permit_holder_address: ADDRESS,
  alt_permit_holder_address: PropTypes.shape({}),
  houseboat: PropTypes.shape({}),
  campsite_reservations: PropTypes.shape({}),
  campsite_preferences: PropTypes.shape({}),
  type: PropTypes.number,
  quota_type: PropTypes.number,
  acquisition_type: PropTypes.number,
  fulfillment_type: PropTypes.number,
  sales_channel_type: PropTypes.number,
  canceled_by: PropTypes.number,
  travel_method_type: PropTypes.number,
  commercial_fields: COMMERCIAL_FIELDS
});

export const LINE_ITEM = PropTypes.shape({
  Dates: PropTypes.shape({
    End: PropTypes.number,
    Start: PropTypes.number
  }),
  Description: PropTypes.string,
  DisplayAs: PropTypes.string,
  FeeType: PropTypes.number,
  Quantity: PropTypes.number,
  Sku: PropTypes.string,
  UnitPrice: PropTypes.number
});

export const LINE_ITEMS = PropTypes.arrayOf(LINE_ITEM);
